var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ backgroundColor: _vm.backgroundColor }),attrs:{"id":"preloader"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"status"}},[_c('div',{staticClass:"status-mes"})])
}]

export { render, staticRenderFns }